export default __webpack_public_path__ + "cb1b7ed4d6d1fbc31d9d54250b9c68e7.png";